import { createSelector } from 'reselect';
import { getHomeSpacesForView } from '@app/selectors/home';

export const getHomeRecentSpaces = createSelector(
  [
    getHomeSpacesForView,
    (state: any) => state.spaceSelector?.recentlyViewedSpaces?.spaceList || [],
  ],
  (spacesForView, recentSpaceList) => {
    const spacesForViewMap = new Map(
      (spacesForView || []).map((s) => [s.objectId || (s as any).id, s])
    );

    return recentSpaceList
      .filter((recentSpace: any) => spacesForViewMap.has(recentSpace.spaceId))
      .map((recentSpace: any) => {
        const space = spacesForViewMap.get(recentSpace.spaceId)!;
        return {
          ...space,
          isStarred: !!space.isStarred,
          lastNavigation: recentSpace.lastNavigation,
        };
      });
  }
);
